import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setLocale } from 'yup';

export default function useTranslationSetup() {
  const { t } = useTranslation('components', { keyPrefix: 'Global.Validations' });

  useEffect(() => {
    setLocale({
      mixed: {
        default: ({ label }) => {
          if (label) {
            return t('invalidWithLabel', { label });
          }
          return t('invalid');
        },
        required: ({ label }) => {
          if (label) {
            return t('requiredWithLabel', {
              label,
            });
          }
          return t('required');
        },
      },
    });
  }, [t]);
}
